import { useMemo } from "react";
import { useSeo, getSiteUrl } from "@/hooks/useSeo";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import LatestUpdates from "./components/LatestUpdates";
import HotRanking from "./components/HotRanking";
import CompletedSection from "./components/CompletedSection";
import FaqSection, { faqItems } from "./components/FaqSection";
import CtaBanner from "./components/CtaBanner";

export default function Home() {
  const jsonLd = useMemo(() => {
    const url = getSiteUrl("/");
    return [
      {
        "@context": "https://storyvault3.github.io",
        "@type": "Organization",
        name: "土豪漫画网",
        url,
        logo: url,
        description: "《家庭教师》漫画全集免费阅读平台,海量热血少年漫画免费在线看。",
      },
      {
        "@context": "https://storyvault3.github.io",
        "@type": "WebSite",
        name: "土豪漫画网",
        url,
        potentialAction: {
          "@type": "SearchAction",
          target: `${getSiteUrl("/category")}?search={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://storyvault3.github.io",
        "@type": "WebPage",
        name: "《家庭教师》漫画全集免费阅读-土豪漫画网",
        url,
        description:
          "《家庭教师》漫画全集在土豪漫画网可免费阅读,为您提供沉浸式的完整故事体验,高清画质,每日更新。",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://storyvault3.github.io",
        "@type": "FAQPage",
        mainEntity: faqItems.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
    ];
  }, []);

  useSeo({
    title: "《家庭教师》漫画全集免费阅读-土豪漫画网",
    description:
      "《家庭教师》漫画全集在土豪漫画网可免费阅读,为您提供沉浸式的完整故事体验。高清画质,每日更新,海量热血少年漫画免费在线看,人气排行、完结推荐一应俱全。",
    keywords: "家庭教师,漫画全集,免费阅读,土豪漫画网,少年漫画",
    path: "/",
    jsonLd,
  });

  return (
    <div className="flex min-h-screen flex-col">
      <main>
        <HeroSection />
        <CategoryNav />
        <LatestUpdates />
        <HotRanking />
        <CompletedSection />
        <FaqSection />
        <CtaBanner />
      </main>
    </div>
  );
}